// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `/**
 * Campaign Section CSS Module
 * Shared styles for campaign sections (tournaments, prize-pop, etc.)
 * Follows existing Section component patterns for consistency
 */
.p8JKytBOObeNxs05cVeS {
  position: relative;
  display: block;
  opacity: 1;
  pointer-events: all;
  transform: translateX(0);
  overflow: hidden;
  /* Performance optimizations */
  contain: layout style paint;
  transform: translateZ(0);
  backface-visibility: hidden;
  /* Touch optimizations */
  -webkit-tap-highlight-color: transparent;
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  user-select: none;
}
/* Single view state */
.p8JKytBOObeNxs05cVeS[data-view="single"] {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  z-index: 10;
  display: flex;
  flex-direction: column;
  background: var(--app-background, #141414);
  margin-bottom: 0;
  box-shadow: none;
  border: none;
  /* Mobile Safari iframe support */
}
@media (max-width: 768px) {
  .p8JKytBOObeNxs05cVeS[data-view="single"] {
    height: calc(var(--app-height, 100vh) - var(--tournament-navigator-height));
  }
}
`, "",{"version":3,"sources":["webpack://./src/features/campaigns/components/MultiViewCampaignSection/components/CampaignSectionContainer/CampaignSectionContainer.module.css"],"names":[],"mappings":"AAAA;;;;EAIE;AACF;EACE,kBAAkB;EAClB,cAAc;EACd,UAAU;EACV,mBAAmB;EACnB,wBAAwB;EACxB,gBAAgB;EAChB,8BAA8B;EAC9B,2BAA2B;EAC3B,wBAAwB;EACxB,2BAA2B;EAC3B,wBAAwB;EACxB,wCAAwC;EACxC,2BAA2B;EAC3B,yBAAyB;EACzB,iBAAiB;AACnB;AACA,sBAAsB;AACtB;EACE,eAAe;EACf,MAAM;EACN,OAAO;EACP,QAAQ;EACR,SAAS;EACT,WAAW;EACX,aAAa;EACb,sBAAsB;EACtB,0CAA0C;EAC1C,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,iCAAiC;AACnC;AACA;EACE;IACE,2EAA2E;EAC7E;AACF","sourcesContent":["/**\n * Campaign Section CSS Module\n * Shared styles for campaign sections (tournaments, prize-pop, etc.)\n * Follows existing Section component patterns for consistency\n */\n.campaignSectionContainer {\n  position: relative;\n  display: block;\n  opacity: 1;\n  pointer-events: all;\n  transform: translateX(0);\n  overflow: hidden;\n  /* Performance optimizations */\n  contain: layout style paint;\n  transform: translateZ(0);\n  backface-visibility: hidden;\n  /* Touch optimizations */\n  -webkit-tap-highlight-color: transparent;\n  -webkit-touch-callout: none;\n  -webkit-user-select: none;\n  user-select: none;\n}\n/* Single view state */\n.campaignSectionContainer[data-view=\"single\"] {\n  position: fixed;\n  top: 0;\n  left: 0;\n  right: 0;\n  bottom: 0;\n  z-index: 10;\n  display: flex;\n  flex-direction: column;\n  background: var(--app-background, #141414);\n  margin-bottom: 0;\n  box-shadow: none;\n  border: none;\n  /* Mobile Safari iframe support */\n}\n@media (max-width: 768px) {\n  .campaignSectionContainer[data-view=\"single\"] {\n    height: calc(var(--app-height, 100vh) - var(--tournament-navigator-height));\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"campaignSectionContainer": `p8JKytBOObeNxs05cVeS`
};
export default ___CSS_LOADER_EXPORT___;
